import React from "react";
import "../../Template02/Combined.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

function Gallery() {
  return (
    <>
      {/* Header */}
      <Header />

      <div>
        <div id="gallery" className="page wb-page">
          {/* Breadcrumb Section */}
          <section
            id="section-3592647"
            className="breadcrumb-section dark sec-padding-lg"
            style={{
              backgroundImage:
                "url(https://images.pexels.com/photos/8442620/pexels-photo-8442620.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }}
          >
            <div className="container boxWidget">
              <div className="col-lg-6">
                <div className="richTextWidget title-heading">
                  <h1>Explore Our Facilities</h1>
                </div>
              </div>
            </div>
          </section>
          

          {/* Gallery Section */}
          <section id="section-3592651" className="widget-section">
            <div className="grid wow slideInDown">
              <ul className="imageListsWidget imgs-gallery">
                {/* Formulation Research and Development */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image1"
                      className="lazyload"
                      alt="Formulation Research and Development"
                      src="//images.pexels.com/photos/20140024/pexels-photo-20140024.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Formulation Research & Development</h2>
                      <p>
                        Our state-of-the-art facilities are dedicated to advancing
                        pharmaceutical formulations, focusing on innovative drug
                        delivery systems and improving patient outcomes.
                      </p>
                    </figcaption>
                  </figure>
                </li>

                {/* Medical Device Development */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image2"
                      className="lazyload"
                      alt="Medical Device Development"
                      src="//images.pexels.com/photos/8657287/pexels-photo-8657287.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Medical Device Development</h2>
                      <p>
                        Our team designs cutting-edge medical devices that provide
                        effective solutions for both clinical settings and home care.
                      </p>
                    </figcaption>
                  </figure>
                </li>

                {/* Quality Control */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image3"
                      className="lazyload"
                      alt="Quality Control"
                      src="//images.pexels.com/photos/8442620/pexels-photo-8442620.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Quality Control</h2>
                      <p>
                        Rigorous quality control ensures that every product meets
                        the highest global standards for safety, efficacy, and quality.
                      </p>
                    </figcaption>
                  </figure>
                </li>

                {/* Research and Development */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image4"
                      className="lazyload"
                      alt="Research and Development"
                      src="//images.pexels.com/photos/8376231/pexels-photo-8376231.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Research and Development</h2>
                      <p>
                        We lead the industry with cutting-edge research that
                        shapes the future of healthcare solutions, including novel
                        drugs and innovative therapies.
                      </p>
                    </figcaption>
                  </figure>
                </li>

                {/* Regulatory Compliance */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image5"
                      className="lazyload"
                      alt="Regulatory Compliance"
                      src="//images.pexels.com/photos/7904433/pexels-photo-7904433.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Regulatory Compliance</h2>
                      <p>
                        We adhere to the most stringent international regulatory
                        requirements to ensure all our products meet the highest
                        standards for safety and quality.
                      </p>
                    </figcaption>
                  </figure>
                </li>

                {/* Global Distribution */}
                <li className="js_image_gallary">
                  <figure className="effect-sadie">
                    <img
                      id="image6"
                      className="lazyload"
                      alt="Global Distribution"
                      src="//images.pexels.com/photos/9742749/pexels-photo-9742749.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200"
                      width=""
                      height=""
                    />
                    <figcaption className="text-center">
                      <h2>Global Distribution</h2>
                      <p>
                        Our global distribution network ensures that top-quality
                        pharmaceutical and medical solutions reach healthcare
                        providers and patients worldwide.
                      </p>
                    </figcaption>
                  </figure>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Gallery;
